module.exports = __webpack_public_path__ + "static/media/BikeSharing-Poster.e2a34ce9.png";